define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ExpandTextInstance = /** @class */ (function () {
        function ExpandTextInstance() {
        }
        ExpandTextInstance.expandContainer = function (expandableContainer) {
            var expandableLink = $('a[data-target="' + expandableContainer.attr('id') + '"]');
            if (this.isLinkExpanded(expandableLink)) {
                return;
            }
            this.toggleLink(expandableLink, expandableContainer);
        };
        ExpandTextInstance.toggleLink = function (expandableLink, expandableContainer) {
            if (this.isLinkExpanded(expandableLink)) {
                expandableLink.removeClass('active');
                expandableLink.attr('title', expandableLink.attr('data-title-collapsed'));
                expandableContainer.slideUp().addClass('rs_skip');
                return;
            }
            expandableLink.addClass('active');
            expandableLink.attr('title', expandableLink.attr('data-title-expanded'));
            expandableContainer.slideDown().removeClass('rs_skip');
        };
        ExpandTextInstance.isLinkExpanded = function (expandableLink) {
            return expandableLink.hasClass('active');
        };
        return ExpandTextInstance;
    }());
    exports.default = ExpandTextInstance;
});
